<template>
  <div>
    <v-data-table :headers="header" :items="items" group-by="bank_code">
      <!-- eslint-disable-next-line -->
      <template v-slot:item.actions="{ item }">
        <button-tooltip
          fab
          icon
          small
          buttonIcon="mdi-pencil"
          tooltipText="Editar"
          @click="edit(item)"
        />
        <button-tooltip
          fab
          icon
          small
          buttonIcon="mdi-content-copy"
          tooltipText="Copiar configuração"
          @click="openCopyDialog(item)"
        />
      </template>

      <!-- eslint-disable-next-line -->
      <template v-slot:group.header="{ isOpen, toggle }">
        <th colspan="12">
          <v-icon @click="toggle">
            {{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
          </v-icon>
        </th>
      </template>
    </v-data-table>

    <copy-config-dialog
      v-model="copyDialogOpen"
      :source-config="selectedConfig"
      @copied="$emit('refresh')"
    />
  </div>
</template>

<script>
import CopyConfigDialog from './components/CopyConfigDialog.vue';

export default {
  name: 'ApiBankingConfigListTable',

  components: {
    CopyConfigDialog,
  },

  props: {
    items: Array,
  },

  data() {
    return {
      header: [
        { text: 'Banco', value: 'bank_name' },
        { text: 'Nome', value: 'name' },
        { text: 'Serviço', value: 'service' },
        { text: 'Versão', value: 'version' },
        { text: '', value: 'actions', sortable: false },
      ],
      copyDialogOpen: false,
      selectedConfig: null,
    };
  },

  methods: {
    edit(item) {
      const params = {
        service: item.id,
        type: item.company_type,
        company: item.company_type_id,
      };

      this.$router.push({ name: 'APIConfigurationsEdit', params });
    },

    openCopyDialog(item) {
      this.selectedConfig = item;
      this.copyDialogOpen = true;
    },
  },
};
</script>

<style></style>
